import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsLimitedClusterSubView } from '@/hooks';
import { ROUTE_ALIASES } from '@/routing/routesAliases';

type LimitedClusterSubRouteGuardProps = {
  children: ReactNode;
};

const isAllowedLimitedClusterSubPath = ({ pathname }: { pathname: string }): boolean => {
  if (pathname.startsWith(ROUTE_ALIASES.PARISH_INFO_ROOT)) {
    return true;
  }

  if (pathname.startsWith(ROUTE_ALIASES.PARISH_DETAILS_ROOT)) {
    return true;
  }

  return false;
};

export const LimitedClusterSubRouteGuard = ({ children }: LimitedClusterSubRouteGuardProps) => {
  const location = useLocation();
  const isLimitedClusterSubView = useIsLimitedClusterSubView();

  if (!isLimitedClusterSubView) {
    return children;
  }

  if (isAllowedLimitedClusterSubPath({ pathname: location.pathname })) {
    return children;
  }

  return <Navigate to={ROUTE_ALIASES.PARISH_INFO_ROOT} replace />;
};
